export default __webpack_public_path__ + "static/media/loginphone_motorola-motoe-black-portrait.a66fa412.png";